import React from 'react';
import getConfig from 'next/config';
import { captureException } from '../../util/sentry';

const config = getConfig().publicRuntimeConfig;

export default class NotifyUnauthorizedDomain extends React.Component {

	constructor(props) {
		super(props);
	}

	componentDidMount() {
		const serverUrl = config.serverUrl;
		let host = serverUrl.replace(/http:\/\//, '').replace(/https:\/\//, '').replace(/\/$/, '');

		let pagePort = window.location.port;
		let pageHost = window.location.hostname;

		if (pagePort && pagePort !== '80' && pagePort !== '443') {
			pageHost = pageHost + ':' + pagePort;
		}

		try {
			if (host !== pageHost && this.props.notify) {
				throw new Error(`Page rendered on unexpected domain. Expected '${host}' but was '${pageHost}'`);
			}
		}
		catch (e) {

			if (window.eventDispatcher) {
				window.eventDispatcher.dispatchEvent('domainError', {expected: host, found: pageHost}, {amplitude: true});
			}

			captureException(e, {});
		}
	}

	render() {
		return null;
	}
}
